import 'reflect-metadata';
import 'react-native-get-random-values';
import { registerRootComponent } from 'expo';
import App from './src/app/app';

registerRootComponent(App);
